<template>
  <div id="init-home-container" class="mt-3 d-flex" style="width: 100%">
    <!--//@*/*
    //    *RPD CSIG  App v0.91
    //    * Copyright (c) 2024, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <template>
      <div class="text-center">
        <!-- set remind -->
        <template>
          <div class="text-center">
            <v-dialog v-model="show_remind_diag" width="500">
              <v-card>
                <v-card-title
                  class="text-h5 grey lighten-2"
                  style="word-break: normal"
                >
                  Set Reminder
                </v-card-title>

                <v-card-text>
                  <template>
                    <v-form v-model="frm_remind_valid" ref="frm_assign">
                      <v-container>
                        <p>
                          Please enter a Date and a Note. An email will be sent
                          5 days before and on the date.
                        </p>
                        <v-row dense>
                          <v-col cols="12" md="12">
                            <v-text-field
                              placeholder="##/##/####"
                              v-model="remind_awd.date_rem"
                              v-mask="'##/##/####'"
                              label="Date"
                              required
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12" md="12">
                            <v-textarea
                              v-model="remind_awd.note"
                              required
                              solo
                              name="note"
                              label="Note"
                              auto-grow
                              counter="4000"
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </template>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="cmpbk" class="white--text" @click="add_reminder"
                    >Submit
                  </v-btn>
                  <v-btn text @click="show_remind_diag = false">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
        <!-- set assingn -->
        <template>
          <div class="text-center">
            <v-dialog v-model="show_assing_diag" width="500">
              <v-card>
                <v-card-title
                  class="text-h5 grey lighten-2"
                  style="word-break: normal"
                >
                  Email Assign
                </v-card-title>

                <v-card-text>
                  <template>
                    <v-form v-model="frm_ass_valid" ref="frm_assign">
                      <v-container>
                        <p>
                          Please enter the email of the person assigned to this
                          Award Nomination. 
                        </p>
                        <v-row dense>
                          <v-col cols="12" md="12">
                            <v-text-field
                              v-model="ass_awd.assigned"
                              :rules="emailRules"
                              label="E-mail"
                              required
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-form>
                  </template>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="cmpbk"
                    class="white--text"
                    @click="set_assign_now"
                    >Submit
                  </v-btn>
                  <v-btn text @click="close_assing_diag">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </template>
        <!-- updated  -->
        <v-dialog
          fullscreen
          persistent
          v-model="show_edit_dialog_updated"
          width="500"
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Edit Award Nomination
            </v-card-title>

            <v-card-actions class="pa-2 awd-btn d-flex flex-lg-row">
              <v-spacer></v-spacer>
              <!-- <v-btn
                @click="awd_save_draft_x(csig_pub)"
                class="black white--text"
                ><v-icon left> $save </v-icon>Save As Draft</v-btn
              > -->
              <v-btn
                @click="awd_save_updated(awd_edit_admin)"
                class="black white--text ml-0 mb-1 mb-lg-0 mr-lg-2 mr-md-1"
                ><v-icon left> $save </v-icon>Save</v-btn
              >
              <!-- <v-btn
                @click="awd_save_published_prompt(csig_pub)"
                class="black white--text ml-0 mb-1 mb-lg-0 mr-md-1"
                ><v-icon left> $save </v-icon>Save As Published</v-btn
              > -->
              <v-btn
                class="ml-0 mr-md-1"
                color="primary"
                text
                @click="close_edit_publish"
              >
                Close
              </v-btn>
            </v-card-actions>
          
            <v-divider class="mb-4"></v-divider>
            <v-card-text>
              <v-container
                class="whitesmoke black--text"
                id="home-container"
                style="max-width: 768px"
              >
                <h4 class="whitesmoke black--text">
                  Please complete the form and submit.
                </h4>
                <v-form ref="form" lazy-validation v-model="valid">
                  <v-container>
                    <v-row dense style="margin-bottom: 0; padding-bottom: 0">
                      <v-col cols="12" md="12">
                        <label>Log of Updates and Actions</label>
                        <v-textarea
                          maxlength="7999"
                          v-model="awd_edit_admin.action_log"
                          name="update_log"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>

                    <v-btn
                      class="black white--text mb-2"
                      style="position: relative; top: -5px"
                      @click="add_to_log(awd_edit_admin)"
                      >Add to Log</v-btn
                    >
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-textarea
                          maxlength="7999"
                          name="add_to_log"
                          v-model="new_log_text"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                        <!-- <v-text-field
                          solo
                          v-model="new_log_text"
                          placeholder="Enter new update/action here."
                        ></v-text-field> -->
                      </v-col>
                    </v-row>
                    <v-divider class="mb-4"></v-divider>
                      <v-row dense>
                        <v-col cols="12" >
                      <v-textarea
                          v-model="awd_edit_admin.nominatedEmployee"
                          style="min-height: 48px;"
                          outlined
                          dense
                          auto-grow
                          rows="2"
                          readonly
                          label="Name:"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" md="4">
                        <v-text-field
                        readonly
                          v-model="awd_edit_admin.submit_date"
                          label="Date:"
                          required
                          v-mask="'##/##/####'"
                        ></v-text-field>
                      </v-col>


                      <v-col cols="12" md="4">
                        <v-text-field
                          maxlength="50"
                          :value="'AWD' + awd_edit_admin.award_nom_adminId_award_nomId + '-' + awd_edit_admin.ordinal"
                          label="REF NUM"
                          readonly
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-text-field
                            readonly
                          v-model="awd_edit_admin.selectedMedal"
                          label="Selected Medal:"
                          required
                       
                        ></v-text-field>
                      </v-col>
                       </v-row>
                       <v-row>
                        <v-col cols="12" md="6">
                        <v-text-field
                          maxlength="120"
                          v-model="awd_edit_admin.eventCaseOrCallNumber"
                          label="Event Case Or Call Number:"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="6">
                        <v-text-field
                          maxlength="50"
                          v-model="awd_edit_admin.assigned"
                          label="Assigned"
                          readonly
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Nomination Narrative  (read only):</label>
                        <v-textarea
                          maxlength="7999"
                          v-model="awd_edit_admin.nominationNarrative"
                          name="nominationNarrative"
                          auto-grow
                          counter
                          outlined
                          dense
                          readonly
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Internal Note (8000 char.):</label>
                        <v-textarea
                          maxlength="7999"
                          v-model="awd_edit_admin.note"
                          name="intertenalnote"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="d-flex flex-md-row flex-column">
              <v-spacer></v-spacer>
              <!-- <v-btn
                @click="awd_save_draft_x(csig_pub)"
                class="black white--text"
                ><v-icon left> $save </v-icon>Save As Draft</v-btn
              > -->
              <v-btn
                @click="awd_save_updated(awd_edit_admin)"
                class="black white--text ml-0 mb-1 mb-lg-0 mr-md-1"
                ><v-icon left> $save </v-icon>Save</v-btn
              >
              <!-- <v-btn
                @click="awd_save_published_prompt(csig_pub)"
                class="black white--text"
                ><v-icon left> $save </v-icon>Save As Published</v-btn
              > -->
              <v-btn color="primary" text @click="close_edit_publish">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
		
        <!-- recieved to draft or updated -->
        <v-dialog fullscreen persistent v-model="show_edit_dialog" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Edit Award Nomination to Update
            </v-card-title>

            <v-card-actions class="pa-2 awd-btn d-flex flex-lg-row">
              <!-- <v-spacer></v-spacer> -->
              <!-- <v-btn
                @click="awd_save_draft(csig)"
                class="black white--text mb-1 mb-lg-0 mr-md-1"
              >
                <v-icon left> $save </v-icon>Save As Draft</v-btn
              > -->
              <v-btn
                @click="awd_save_updated(awd_item)"
                class="black white--text ml-0 mb-1 mb-lg-0 mr-md-1"
              >
                <v-icon left> $save </v-icon> Save</v-btn
              >
              <v-btn
                color="primary"
                text
                @click="close_edit"
                class="ml-0 mr-md-1"
              >
                Close
              </v-btn>
            </v-card-actions>
            <v-divider></v-divider>
            <v-card-text class="form-edit px-4">
              <v-container id="home-container" style="max-width: 768px">
                <h4 class="whitesmoke black--text">
                  Please complete the form and submit.
                </h4>
                <v-form ref="form" lazy-validation v-model="valid">
                  <v-container>
                    <v-row dense>
                      <v-col cols="12">
                      <v-textarea
                          v-model="awd_item.nominatedEmployee"
                          style="min-height: 48px;"
                          outlined
                          dense
                          auto-grow
                          rows="2"
                          readonly
                          label="Name:"
                        ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="awd_item.submit_date"
                          label="Date:"
                          required
                          v-mask="'##/##/####'"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-text-field
                          maxlength="120"
                          v-model="awd_item.submittedByEmail"
                          label="Submitted by Email:"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                        readonly
                          v-model="awd_item.hasSupportingDocumentation"
                          label="Files?:"
                          required
                    
                        ></v-text-field>
                      </v-col>
                    </v-row>
<!-- submittedByEmail -->
 <!-- hasSupportingDocumentation -->
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Narrative (read only):</label>
                        <v-textarea
                          maxlength="7999"
                          v-model="awd_item.nominationNarrative"
                          name="Comments"
                          auto-grow
                          counter
                          outlined
                          dense
                          readonly
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Internal Note (8000 char.):</label>
                        <v-textarea
                          maxlength="7999"
                          v-model="awd_item.note"
                          name="note"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn @click="awd_save_draft(csig)" class="black white--text">
                <v-icon left> $save </v-icon>Save As Draft</v-btn
              > -->
              <v-btn @click="awd_save_updated(awd_item)" class="black white--text">
                <v-icon left> $save </v-icon> Save</v-btn
              >
              <v-btn color="primary" text @click="close_edit"> Close </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- draft to updated -->
        <v-dialog
          fullscreen
          persistent
          v-model="show_edit_draft_to_updated"
          width="500"
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Edit Public Comment For Update
            </v-card-title>

            <v-card-actions class="pa-2 awd-btn d-flex flex-lg-row">
              <v-spacer></v-spacer>
              <v-btn
                @click="has_draft_x(csig_pub)"
                class="black white--text mb-1 mb-lg-0 mr-md-1"
              >
                <v-icon left> $save </v-icon>Save As Draft</v-btn
              >
              <v-btn
                @click="awd_save_updated(csig_pub)"
                class="black white--text ml-0 mb-1 mb-lg-0 mr-md-1"
              >
                <v-icon left> $save </v-icon>Save</v-btn
              >
              <v-btn
                class="ml-0 mr-md-1"
                color="primary"
                text
                @click="close_edit_draft_to_updated"
              >
                Close
              </v-btn>
            </v-card-actions>
            <v-divider></v-divider>
            <v-card-text>
              <v-container
                class="whitesmoke black--text"
                id="home-container"
                style="max-width: 768px"
              >
                <h4 class="whitesmoke black--text">
                  Please complete the this form and submit.
                </h4>
                <v-form ref="form" lazy-validation v-model="valid">
                  <v-container>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="csig_pub.submit_date"
                          label="Date:"
                          required
                          v-mask="'##/##/####'"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-text-field
                          maxlength="120"
                          v-model="csig_pub.name"
                          label="Name (optional):"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-text-field
                          maxlength="50"
                          v-model="csig_pub.division"
                          :rules="requiredRule"
                          label="Division most impacted:"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Comment (8000 char.):</label>
                        <v-textarea
                          :rules="requiredRule"
                          maxlength="7999"
                          v-model="csig_pub.comments"
                          name="comments"
                          label=""
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>awdgested Solution (8000 char.):</label>
                        <v-textarea
                          :rules="requiredRule"
                          aria-required
                          required
                          maxlength="7999"
                          v-model="csig_pub.solution"
                          name="solution"
                          label=""
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <label for="policy">Is there a policy in place?</label>
                        <div style="visibility: hidden">row space</div>
                        <v-select
                          id="policy"
                          v-model="csig_pub.policy"
                          :items="policy_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <label for="speak"
                          >Would you like to speak with someone regarding this
                          issue?</label
                        >
                        <v-select
                          id="speak"
                          v-model="csig_pub.speak"
                          :items="speak_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row v-if="csig_pub.speak == 'Yes'">
                      <v-col cols="12" md="12">
                        <v-text-field
                          maxlength="120"
                          v-model="csig_pub.speak_name"
                          label="Who would you like to speak with?:"
                          placeholder="Enter Full Name"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="6">
                        <label for="cost"
                          >Is there a financial cost to the solution?</label
                        >
                        <v-select
                          id="cost"
                          v-model="csig_pub.cost"
                          :items="cost_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <label for="funding"
                          >Has a funding stream been identified?</label
                        >
                        <v-select
                          id="funding"
                          v-model="csig_pub.funding"
                          :items="funding_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label
                          >If funding stream yes, please discuss (8000
                          char.):</label
                        >
                        <v-textarea
                          maxlength="7999"
                          v-model="csig_pub.stream_discuss"
                          name="stream_discuss"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Other comments (8000 char.):</label>
                        <v-textarea
                          maxlength="7999"
                          v-model="csig_pub.comments"
                          name="stream_discuss"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="has_draft_x(csig_pub)" class="black white--text">
                <v-icon left> $save </v-icon> Save As Draft</v-btn
              >
              <v-btn
                @click="awd_save_updated(csig_pub)"
                class="black white--text"
              >
                <v-icon left> $save </v-icon> Save</v-btn
              >
              <v-btn color="primary" text @click="close_edit_draft_to_updated">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


        <!--  view read only -->
        <v-dialog fullscreen persistent v-model="show_view" width="500">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              View - Read Only
            </v-card-title>

            <v-card-actions>
              <v-btn class="black white--text" text @click="close_view">
                Close
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
            <v-card-text>
              <v-container
                class="whitesmoke black--text"
                id="home-container"
                style="max-width: 768px"
              >
                <h4 class="whitesmoke black--text">
                  Please complete the form and submit.
                </h4>
                <v-form ref="form" lazy-validation v-model="valid">
                  <v-container>
                    <v-row dense style="margin-bottom: 0; padding-bottom: 0">
                      <v-col cols="12" md="12">
                        <label>Log of Updates and Actions</label>
                        <v-textarea
                          style="height: 150px"
                          maxlength="7999"
                          v-model="csig_pub.action_log"
                          name="update_log"
                          counter
                          outlined
                          dense
                          readonly
                        ></v-textarea>
                      </v-col>
                    </v-row>

                    <v-divider class="mb-4"></v-divider>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-text-field
                          v-model="csig_pub.submit_date"
                          label="Date:"
                          required
                          v-mask="'##/##/####'"
                          readonly
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-text-field
                          readonly
                          maxlength="120"
                          v-model="csig_pub.name"
                          label="Name (optional):"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="4">
                        <v-text-field
                          readonly
                          maxlength="50"
                          v-model="csig_pub.division"
                          :rules="requiredRule"
                          label="Division most impacted:"
                          required
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label
                          >Primary Request/Public Comment (8000 char.):</label
                        >
                        <v-textarea
                          readonly
                          :rules="requiredRule"
                          maxlength="7999"
                          v-model="csig_pub.request"
                          name="request"
                          label=""
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>awdgested Solution (8000 char.):</label>
                        <v-textarea
                          readonly
                          :rules="requiredRule"
                          aria-required
                          required
                          maxlength="7999"
                          v-model="csig_pub.solution"
                          name="solution"
                          label=""
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6">
                        <label for="policy">Is there a policy in place?</label>
                        <div style="visibility: hidden">row space</div>
                        <v-select
                          readonly
                          id="policy"
                          v-model="csig_pub.policy"
                          :items="policy_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <label for="speak"
                          >Would you like to speak with someone regarding this
                          issue?</label
                        >
                        <v-select
                          readonly
                          id="speak"
                          v-model="csig_pub.speak"
                          :items="speak_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row v-if="csig_pub.speak == 'Yes'">
                      <v-col cols="12" md="12">
                        <v-text-field
                          readonly
                          maxlength="120"
                          v-model="csig_pub.speak_name"
                          label="Who would you like to speak with?:"
                          placeholder="Enter Full Name"
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="6">
                        <label for="cost"
                          >Is there a financial cost to the solution?</label
                        >
                        <v-select
                          readonly
                          id="cost"
                          v-model="csig_pub.cost"
                          :items="cost_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="6">
                        <label for="funding"
                          >Has a funding stream been identified?</label
                        >
                        <v-select
                          readonly
                          id="funding"
                          v-model="csig_pub.funding"
                          :items="funding_items"
                          solo
                          attach
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label
                          >If funding stream yes, please discuss (8000
                          char.):</label
                        >
                        <v-textarea
                          readonly
                          maxlength="7999"
                          v-model="csig_pub.stream_discuss"
                          name="stream_discuss"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="12">
                        <label>Other comments (8000 char.):</label>
                        <v-textarea
                          readonly
                          maxlength="7999"
                          v-model="csig_pub.comments"
                          name="stream_discuss"
                          auto-grow
                          counter
                          outlined
                          dense
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn class="black white--text" text @click="close_view">
                Close
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

    <auth></auth>

    <v-spacer></v-spacer>
    <v-main>
      <v-container
        class="whitesmoke black--text"
        id="home-container"
        style="max-width: 768px"
      >
        <!-- <v-btn color="green" class="ma-3" @click="devadmin = !devadmin"
          >DEV Admin Toggle</v-btn
        > -->
        <h4 class="whitesmoke black--text" v-if="isadmin">
          Admin Area - {{ loggedin }}
        </h4>
        <v-card v-if="isadmin" color="white" class="white">
          <v-card-title>Award Nominations</v-card-title>
          <!-- <v-card-actions>
            <v-btn
              class="white--text"
              color="cmpbk"
              large
              style="width: 100%"
              @click="new_pubcom"
              >Submit New awdgestion</v-btn
            >
          </v-card-actions> -->
          <!-- <v-btn v-if="debug" @click="SendEmails">send emails reminder</v-btn> -->
          <!-- filters -->
          <div class="filter-title ml-2">Filters:&nbsp; &nbsp;</div>
          <v-card-actions class="filter-btn-cntnr">
            <v-btn-toggle
              v-model="toggle_exclusive"
              mandatory
              class="filter-btn d-flex flex-lg-row flex-lg-nowrap flex-column flex-wrap"
            >
              <!-- color="indigo darken-4" class="white--text" -->
              <v-btn class=""> Received </v-btn>
              <v-btn class=""> Updated </v-btn>
              <!-- <v-btn class=""> Published </v-btn>
              <v-btn class=""> Your Drafts </v-btn> -->
            </v-btn-toggle>
          </v-card-actions>
          <!-- recieved -->
          <div v-if="toggle_exclusive == 0">
            <v-card
              class="awd-v-card mb-6 findit"
              elevation="2"
              style="width: 98%; margin: auto; margin-bottom: 20px"
            >
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="12" class="d-flex">
                    <v-text-field
                      clearable
                      label="Find:"
                      v-model="quickfind"
                      @input="qfind"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
<!-- //recived -->
            <v-card
              v-for="awd in lst_recieved"
              :key="awd.award_nomId"
              color="whitesmoke"
              class="awd-v-card mb-6 findme"
              elevation="2"
              shaped
              style="width: 98%; margin: auto; margin-bottom: 20px"
              :id="'rcv' + awd.award_nomId"
            >
              <v-card-text>
                <v-container>
                  <v-row dense>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Submit Date: &nbsp;</label>
                      <article>{{ awd.submit_date }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Modified: &nbsp;</label>
                      <article>{{ awd.s_date }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>SelectedMedal: &nbsp;</label>
                      <article>{{ awd.selectedMedal }}</article>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" md="12" class="d-flex">
                      <label>Name &nbsp;</label>
                     
                      <v-textarea
                          v-model="awd.nominatedEmployee "
                          style="min-height: 48px;"
                          outlined
                          dense
                          auto-grow
                          rows="2"
                          readonly
                        ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row dense>

                    <v-col cols="12" md="6" class="d-flex">
                      <label>Ref Num: </label>
                      <article>&nbsp;AWD{{ awd.award_nomId }}</article>
                    </v-col>
                    <v-col cols="12" md="6" class="d-flex">
                      <label
                        class="font-weight-bold"
                        :style="{ color: awd.text_color }"
                        >Status: &nbsp;</label
                      >
                      <article
                        class="font-weight-bold"
                        :style="{ color: awd.text_color }"
                      >
                        {{ awd.status }}
                      </article>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6" class="d-flex">
                      <label>Email of Nomination: &nbsp;</label>
                      <article>{{ awd.submittedByEmail }}</article>
                    </v-col>
                    <v-col cols="12" md="6" class="d-flex">
                      <label>Event case or call number: &nbsp;</label>
                      <article>{{ awd.eventCaseOrCallNumber }}</article>
                    </v-col>

                       </v-row>
                    <v-row>
                        <v-col cols="12" md="12" class="d-flex">
                        <label>Has supporting documentation : &nbsp;</label>
                        <article>{{ awd.hasSupportingDocumentation }}</article>
                        </v-col>
                  </v-row>

                   <template v-if="awd.hasSupportingDocumentation == 'Yes'"  >
                                      <v-row>
                    <v-col cols="12" md="12" class="d-flex">
                      <label>Links to uploaded files : &nbsp;</label>
                    </v-col>
                  </v-row>
               <v-row v-for="file in (awd.lst_files || [])" :key="file.award_filenameId">

                    <v-col cols="12" md="12" class="d-flex pa-2">
                   
                      <!-- https://award.renopd.com/Upload/2882156-purple_worms.png -->
                      <a style="width: 100%;" class="blue--text"
                     
                        :href="'https://award.renopd.com/Upload/' + file.filename"
                        target="_blank"
                        v-text="'https://award.renopd.com/Upload/' + file.filename"></a>
                    </v-col>
                  </v-row>
                  </template>
                  <v-expansion-panels v-if="awd.nominationNarrative.length >= 100" class="mt-4">
                    <v-expansion-panel>
                      <v-expansion-panel-header @click="expnd_textarea">
                        {{ awd.nominationNarrative | first100 }}
                      </v-expansion-panel-header>
                      <!-- textarea -->
                      <v-expansion-panel-content eager class="textarea-fix">
                        <hr />
                        <textarea
                          readonly
                          style="width: 100%; height: auto"
                          v-model="awd.nominationNarrative"
                        >
                        </textarea>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <label class="d-block mt-5">Narrative:(optional)</label>
                  <textarea
                    style="
                      width: 100%;
                      background-color: white;
                      border: 1px solid darkgray;
                      padding: 5px;
                    "
                    readonly
                    class="sizeme"
                    v-model="awd.nominationNarrative"
                    v-if="awd.nominationNarrative.length < 100"
                  >
                  </textarea>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn  :disabled="awd.status === 'Updated'"
                  color="cmpbk"
                  class="white--text"
                  @click="show_edit_now(awd)"
                  >Edit</v-btn
                >
              </v-card-actions>
            </v-card>
          </div>

          <!--  drafts  -->
          <div v-if="toggle_exclusive == 3">
            <v-card
              v-for="awd in lst_drafts"
              :key="awd.csig_pubId"
              color="whitesmoke"
              class="mb-6"
              elevation="2"
              shaped
              style="width: 98%; margin: auto; margin-bottom: 20px"
            >
              <v-card-text>
                <v-container>
                  <h3>Draft</h3>
                  <v-row dense class="mt-2">
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Assigned: &nbsp;</label>
                      <article>{{ awd.assigned }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Ref Num: </label>
                      <article>&nbsp;CS{{ awd.csigId }}-{{awd.ordinal}}</article>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Submit Date:www &nbsp;</label>
                      <article>{{ awd.submit_date }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Modified: &nbsp;</label>
                      <article>{{ awd.s_date }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Name:aaa &nbsp;</label>
                      <article>{{ awd.name }}</article>
                    </v-col>
                  </v-row>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header @click="expnd_textarea">
                        Comment
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <hr />
                        {{ awd.comments }}
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="
                    edit_allowed(awd, function () {
                      show_edit_now(awd);
                    })
                  "
                  >Edit</v-btn
                >
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="set_assign(awd)"
                  >Assign</v-btn
                >
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="delete_prompt(awd)"
                  >Delete</v-btn
                >
              </v-card-actions>
            </v-card>
            <p class="ml-4 pa-3" v-if="lst_drafts.length == 0">
              You do not have any draft Award Nominations.
            </p>
          </div>
          <!--  updated  -->
          <div v-if="toggle_exclusive == 1">
            <v-card
              class="awd-v-card mb-6 findit"
              elevation="2"
              style="width: 98%; margin: auto; margin-bottom: 20px"
            >
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="12" class="d-flex">
                    <v-text-field
                      clearable
                      label="Find:"
                      v-model="quickfind_updated"
                      @input="qfind_updated"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card
              v-for="awd in lst_updated"
              :key="awd.award_nom_adminId"
              color="whitesmoke"
              class="mb-6 findme-updated"
              elevation="2"
              shaped
              style="width: 98%; margin: auto; margin-bottom: 20px"
              :id="'upd' + awd.award_nom_adminId"
            >
              <v-card-text>
                <v-container>
                  <h3>Updated</h3>
                  <v-row dense class="mt-2">
                    <v-col cols="12" md="6" class="d-flex">
                      <label>Assigned: &nbsp;</label>
                      <article>
                        {{ awd.assigned }} {{ awd.assigned_date | ifnone_dt }}
                      </article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Ref Num: </label>
                      <article>&nbsp;AWD{{ awd.award_nom_adminId_award_nomId }}-{{awd.ordinal }}</article>
                    </v-col>
                  </v-row>
                   <v-row dense>
                       <v-col cols="12" class="d-flex">
                      <label>Nominated Employee: &nbsp;</label>
                      <article>{{ awd.nominatedEmployee }}</article>
                       </v-col>
                   </v-row>
                  <v-row dense>
                    <v-col cols="12" md="6" class="d-flex">
                      <label>Submit Date:&nbsp;</label>
                      <article>{{ awd.submit_date }}</article>
                    </v-col>
                    <v-col cols="12" md="6" class="d-flex">
                      <label>Modified: &nbsp;</label>
                      <article>{{ awd.s_date }}</article>
                    </v-col>

                  </v-row>
                  <v-row dense>
                    <v-col cols="12" md="12" class="d-flex">
                      <label>Submitted By Email: &nbsp;</label>
                      <article>{{ awd.submittedByEmail}}</article>
                    </v-col>

                  </v-row>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header @click="expnd_textarea">
                        Nomination Narrative:
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <hr />
                        {{ awd.nominationNarrative }}
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header @click="expnd_textarea">
                        Internal Note:
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <hr />
                        {{ awd.note }}
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header @click="expnd_textarea">
                       Action Log:
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-textarea
                            readonly
                            maxlength="8000"
                            name="update_log"
                            auto-grow
                            counter
                            outlined
                            dense
                            v-model="awd.action_log"
                          ></v-textarea>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <template v-if="awd.hasSupportingDocumentation == 'Yes'"  >
                    <v-row>
                      <v-col cols="12" md="12" class="d-flex">
                        <label>Links to uploaded files : &nbsp;</label>
                      </v-col>
                    </v-row>
                  <v-row v-for="file in (awd.lst_files || [])" :key="file.award_filenameId">

                    <v-col cols="12" md="12" class="d-flex pa-2">

                      <!-- https://award.renopd.com/Upload/2882156-purple_worms.png -->
                      <a style="width: 100%;" class="blue--text"

                      :href="'https://award.renopd.com/Upload/' + file.filename"
                      target="_blank"
                      v-text="'https://award.renopd.com/Upload/' + file.filename"></a>
                    </v-col>
                  </v-row>
                  </template>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="show_edit_updated_now(awd)"
                  >Edit</v-btn
                >

                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="set_assign(awd)"
                  >Assign</v-btn
                >
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="delete_prompt(awd)"
                  >Delete</v-btn
                >
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="archive_propmpt(awd)"
                  >Archive</v-btn
                >
              </v-card-actions>
            </v-card>
            <p class="ml-4 pa-4" v-if="lst_updated.length == 0">
              There are no updated Award Nominations right now.
            </p>
          </div>
          <!--published  -->
          <div v-if="toggle_exclusive == 2">
            <v-card
              class="awd-v-card mb-6 findit"
              elevation="2"
              style="width: 98%; margin: auto; margin-bottom: 20px"
            >
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="12" class="d-flex">
                    <v-text-field
                      clearable
                      label="Find:"
                      v-model="quickfind_published"
                      @input="qfind_published"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card
              v-for="awd in lst_published"
              :key="awd.csig_pubId"
              color="whitesmoke"
              findme-updated
              elevation="2"
              shaped
              class="findme-published"
              style="width: 98%; margin: auto; margin-bottom: 20px"
              :id="'pub' + awd.csigId"
            >
              <v-card-text>
                <v-container>
                  <h3>Published</h3>
                  <v-row dense class="mt-2">
                    <v-col cols="12" md="6" class="d-flex">
                      <label>Assigned: &nbsp;</label>
                      <article>
                        {{ awd.assigned }} {{ awd.assigned_date | ifnone_dt }}
                      </article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Ref Num: </label>
                      <article>&nbsp;AWD{{ awd.csigId }}</article>
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Submit Date:ttt &nbsp;</label>
                      <article>{{ awd.submit_date }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Modified: &nbsp;</label>
                      <article>{{ awd.s_date }}</article>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex">
                      <label>Name:bbb &nbsp;</label>
                      <article>{{ awd.name }}</article>
                    </v-col>
                  </v-row>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header @click="expnd_textarea">
                        Comment
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <hr />
                        {{ awd.comments }}
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="show_edit_updated_now(awd)"
                  >Edit</v-btn
                >
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="set_assign(awd)"
                  >Assign</v-btn
                >
                <v-btn
                  color="cmpbk"
                  class="white--text"
                  @click="delete_prompt(awd)"
                  >Delete</v-btn
                >
                <v-btn color="cmpbk" class="white--text" @click="remind(awd)"
                  >Remind</v-btn
                >
              </v-card-actions>
            </v-card>
            <p class="ml-4 pa-4" v-if="lst_published.length == 0">
              There are no published Award Nominations right now.
            </p>
          </div>
        </v-card>

        <!-- user read only section -->
        <v-card v-if="isadmin == false" class="mb-5">
          <!-- <v-card-actions>
            <v-btn
              class="white--text"
              color="cmpbk"
              large
              style="width: 100%"
              @click="new_pubcom"
              >Submit New awdgestion</v-btn
            >
          </v-card-actions> -->
          <v-text-field
            v-model="quickfind_view"
            class="white black--text"
            style="width: 96%; margin: 2%"
            label="Filter by"
            placeholder="Keyword"
            solo
            @input="qfind_view"
          ></v-text-field>
          <v-card-title>Published Award Nominations and Outcomes</v-card-title>

          <v-card
            v-for="awd in lst_published"
            :key="awd.csig_pubId"
            :id="'viw' + awd.csigId"
            color="whitesmoke"
            class="mb-6 findme_view"
            elevation="2"
            shaped
            style="width: 98%; margin: auto; margin-bottom: 20px"
          >
            <v-card-text>
              <v-container>
                <h3>Published</h3>
                <v-row dense class="mt-2">
                  <v-col cols="12" md="6" class="d-flex">
                    <label>Assigned: &nbsp;</label>
                    <article class="d-flex">
                      {{ awd.assigned }} {{ awd.assigned_date | ifnone_dt }}
                    </article>
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex">
                    <label>Ref Num: </label>
                    <article>&nbsp;CS{{ awd.csigId }}</article>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" md="4" class="d-flex">
                    <label>Submit Date: yyy &nbsp;</label>
                    <article>{{ awd.submit_date }}</article>
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex">
                    <label>Modified: &nbsp;</label>
                    <article>{{ awd.s_date }}</article>
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex">
                    <label>Name:ccc &nbsp;</label>
                    <article>{{ awd.name }}</article>
                  </v-col>
                </v-row>
                <v-row dense class="mb-3">
                  <v-col cols="12" class="d-flex">
                    <label>Preview: &nbsp;</label>
                    <article>{{ awd.request | previewText }}</article>
                  </v-col>
                </v-row>
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      Request and Updates
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <hr class="mb-3" />
                      <v-row dense style="margin-bottom: 0; padding-bottom: 0">
                        <v-col cols="12" md="12">
                          <label
                            style="
                              font-size: 14px;
                              color: black;
                              font-weight: 600;
                            "
                            >Log of Updates and Actions</label
                          >
                          <v-textarea
                            readonly
                            maxlength="8000"
                            name="update_log"
                            auto-grow
                            counter
                            outlined
                            dense
                            v-model="awd.action_log"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <label
                        style="color: black; font-size: 14px; font-weight: 600"
                        >Request</label
                      >
                      <v-row
                        class="mb-5"
                        dense
                        style="margin-bottom: 0; padding-bottom: 0"
                      >
                        <v-col cols="12" md="12">
                          <v-textarea
                            readonly
                            maxlength="8000"
                            name="update_log"
                            auto-grow
                            counter
                            outlined
                            dense
                            v-model="awd.request"
                          ></v-textarea
                        ></v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn color="cmpbk" class="white--text" @click="open_view(awd)"
                >View</v-btn
              >
            </v-card-actions>
          </v-card>
          <p class="ml-4 pa-4" v-if="lst_published.length == 0">
            There are no published Award Nominations right now.
          </p>
        </v-card>
      </v-container>
    </v-main>
    <v-spacer></v-spacer>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  article {
    color: blue;
  }
  .v-btn-toggle .v-item--active {
    background-color: white !important;
    color: blue !important;
  }

  #home-container {
    width: 94vw;
    max-width: 100vw;
    height: auto;
  }

  .filter-btn {
    width: 100%;
  }

  .filter-title {
    width: 98%;
  }

  .filter-btn-cntnr {
    width: 100%;
  }

  .awd-btn {
    flex-direction: column;
  }

  .awd-btn .v-btn {
    width: 56%;
  }

  .textarea-fix textarea {
    resize: none; /* Disable manual resizing */
    overflow: hidden; /* Prevent scrollbars */
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }

  .alice {
    color: aliceblue;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .awd-btn {
    flex-direction: row;
    justify-content: flex-end;
  }

  .awd-btn .v-btn {
    width: auto;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import auth from "./auth.vue";
//const add_edit = () => import("./add_edit.vue");
        //    [Key]
        // public int award_nomId { get; set; }
        // //submit_date
        // public DateTime submit_date { get; set; }
        // //        selectedMedal
        // [MaxLength(60)]
        // public string selectedMedal { get; set; }

        // //nominatedEmployee
        // [MaxLength(120)]
        // public string nominatedEmployee { get; set; }

        // //eventCaseOrCallNumber
        // [MaxLength(8)]
        // public string eventCaseOrCallNumber { get; set; }

        // //hasSupportingDocumentation
        // [MaxLength(3)]
        // public string hasSupportingDocumentation { get; set; }

        // //nominationNarrative
        // [MaxLength(8000)]
        // public string nominationNarrative { get; set; }

        // //submittedByEmail
        // [MaxLength(120)]
        // public string submittedByEmail { get; set; } 
export default {
  name: "Home",
  components: { auth },
  mixins: [bus_common],
  data() {
    // Status, Fname, Lnprivateame, DOB, DIVISION
    return {
      csig: {}, // or a full default shape
      awd_item: {
        award_nomId: 0,
        submit_date: "",
        nominatedEmployee: "",
        selectedMedal: "",
        eventCaseOrCallNumber: "",
        hasSupportingDocumentation:"",
        nominationNarrative: "",
        updated_date: "",
        assigned: "",
        assigned_date: "",
        action_log: "",
        ordinal:0,
      },
      awd_edit_admin:{},
      debug: true,
      lst_reminders_awd: [],
      cur_awd: {},
      remind_awd: {
        date_rem: "",
        note: "",
      },
      remind_awd_new: {
        date_rem: "",
        note: "",
      },
      frm_remind_valid: true,
      show_remind_diag: false,
      quickfind_view: "",
      quickfind_updated: "",
      quickfind: "",
      quickfind_published: "",
      frm_ass_valid: false,
      show_view: false,
      new_log_text: "",
      ass_awd: {},
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      show_assing_diag: false,
      devadmin: true,
      show_edit_dialog_updated: false,
      show_edit_dialog_pub: false,
      show_edit_draft_to_updated: false,
      csig_pub: {},
      show_edit_dialog: false,
      lst_updated: [],
      lst_drafts: [],
      lst_recieved: [],
      lst_published: [],
      toggle_exclusive: undefined,
      user_props: {},
      policy_items: ["", "Yes", "No", "Do Not Know"],
      speak_items: ["", "Yes", "No"],
      cost_items: ["", "Yes", "No"],
      funding_items: ["", "Yes", "No"],

      new_csig: {
        csig_pubId: 0,
        csigId: 0,
        name: "",
        review: "",
        submit_date: "",

        comments: "",
        note: "",

        updated_date: "",
        assigned: "",
        assigned_date: "",
        action_log: "",
      },
      //       },


      //  [csig_pubId]
      // ,[csigId]
      // ,[name]
      // ,[submit_date]
      // ,[comments]
      // ,[assigned]
      // ,[action_log]
      // ,[draft_date]
      // ,[updated_date]
      // ,[published_date]
      // ,[assigned_date]
      valid: false,
      firstname: "",
      lastname: "",
      requiredRule: [(v) => !!v || "Required"],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => v.length <= 10 || "Name must be less than 10 characters",
      ],
      email: "",
    };
  },
  watch: {
    "$store.state.user": function () {
      if (this.$store.state.user.email != "") {
        let self = this;
        this.init();
      }
    },
  },
  computed: {
    // Define the computed property
    isadmin() {
      // return (
      //   this.$store.state.user.roles.indexOf("csig-admin") > -1 && this.devadmin
      // );
      return true;
    },
    loggedin() {
      return this.$store.state.user.email;
    },
  },
  filters: {
    previewText(value, maxLength = 60) {
      if (!value || typeof value !== "string") return "";
      if (value.length <= maxLength) return value;

      let spaceIndex = value.lastIndexOf(" ", maxLength);

      if (spaceIndex === -1) {
        spaceIndex = value.indexOf(" ", maxLength);
        if (spaceIndex === -1) spaceIndex = maxLength;
      }

      return value.slice(0, spaceIndex) + "…";
    },
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    ifnone_dt(value) {
      if (value == "01/01/1900") {
        return "";
      } else {
        return value;
      }
    },
    first100(value) {
      if (value.length <= 100) {
        return value;
      } else {
        return value.slice(0, 100) + "...";
      }
    },
  },
  methods: {
    SendEmails() {
      //for publish edit

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.apiname = "send_reminder_emails";
      formIn.activate = "stuff";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
archive_propmpt(awd) {
  let self = this;
  this.swall_diag(
    "Confirm Archive",
    "You are permanently archiving Award Nomination AWD" +
      awd.award_nom_adminId_award_nomId +
      "-" +
      awd.ordinal +
      " for " +
      awd.nominatedEmployee +
      ". This record will no longer appear in the active list. If this record ever needs to be unarchived, please send an email to support. Do you wish to continue?",
    "question",
    function () {
      self.archive_now(awd);
    },
    null,
    null,
    function () {},
  );
},

archive_now(awd) {
  let self = this;
  self.show_loader(true);
  let formIn = {};
  formIn.email = this.$store.state.user.email;
  formIn.token = this.$store.state.user.token;
  formIn.apiname = "archive_now";
  formIn.award_nom_adminId = awd.award_nom_adminId;

  this.$store
    .dispatch("anyapi", formIn)
    .then((data) => {
      self.show_loader(false);
      self.swall_it(
        "Archive Status",
        "The record has been archived.",
        "success",
        null,
        null,
      );
      this.$nextTick(() => {
        self.refresh_all();
      });
    })
    .catch((msg) => {
      self.show_loader(false);
      self.swall_it("Error", msg, "error", null, null);
    });
},
    del_reminder_now(rem) {
      //for publish edit

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.apiname = "del_reminder_now";
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.reminderId = rem.reminderId;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.get_reminders4_awd(self.cur_awd);
          self.show_loader(false);
          this.swall_it("reminder Status", "Removed", "success", null, null);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    del_reminder(item) {
      let self = this;
      this.swall_diag(
        "Confirm Delete",
        "You are deleting the reminder for Date: '" +
          item.date_rem +
          "'. Continue?",
        "question?",
        function () {
          self.del_reminder_now(item);
        },
        null,
        null,
        function () {},
      );
    },
    get_reminders4_awd(awd) {
      //for publish edit

      // let self = this;
      // self.show_loader(true);
      // let formIn = {};
      // formIn.apiname = "get_reminders4_awd";
      // formIn.email = this.$store.state.user.email;
      // formIn.token = this.$store.state.user.token;
      // formIn.csig_pubId = awd.csig_pubId;

      // this.$store
      //   .dispatch("anyapi", formIn)
      //   .then((data) => {
      //     self.show_loader(false);
      //     self.lst_reminders_awd = self.mno(data);
      //     self.lst_reminders_awd.forEach((element) => {
      //       element.date_rem = self.format_date_us(element.date_rem);
      //       element.date_rem_5days_prev = self.format_date_us(
      //         element.date_rem_5days_prev,
      //       );
      //     });
      //   })
      //   .catch((msg) => {
      //     this.show_loader(false);
      //     this.swall_it("Error", msg, "error", null, null);
      //   });
    },
    add_reminder(awd) {
      console.log("add_reminder");
      let self = this;
      //validation
      if (this.isValidFutureDate(this.remind_awd.date_rem) == false) {
        self.swall_it(
          "Reminder Status",
          "Date must be valid and within one year of the future.",
          "warning",
          null,
          null,
        );
        return true;
      }

      if (this.remind_awd.date_rem == "") {
        self.swall_it(
          "Reminder Status",
          "Date msut be valid and within one year of the future.",
          "warning",
          null,
          null,
        );

        return true;
      }

      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.csig_pubId = this.cur_awd.csig_pubId;
      formIn.remind_awd = this.remind_awd;

      formIn.remind_awd.date_remx = this.format_date_sql(
        formIn.remind_awd.date_rem,
      );

      formIn.apiname = "add_reminder";
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.remind_awd = self.mno(self.remind_awd_new);
          self.remind_awd.date_rem = "";
          self.show_remind_diag = false;
          self.swall_it("Reminder Status", "Added.", "success", null, null);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    remind(awd) {
      //set a rminder for a date to take action.
      //a job will run to set the notifcations.
      //it should have a note.  5 days ahead.
      this.show_remind_diag = true;
      this.cur_awd = awd;
    },
    qfind_view() {
      if (this.quickfind_view != null && this.quickfind_view.length >= 3) {
        console.log("qfind_view " + this.quickfind_view);
        let lstcrds = document.querySelectorAll(".findme_view");
        lstcrds.forEach((element) => {
          element.style.display = "none";
        });

        //find things here
        lstcrds.forEach((element) => {
          let id = element.id;
          let idint = id.slice(3);

          const result = this.lst_published.find(
            (item) => parseInt(item.csigId) === parseInt(idint),
          );
          if (
            result.comments
              .toLowerCase()
              .indexOf(this.quickfind_view.toLowerCase()) > -1
          ) {
            element.style.display = "block";
          }

          if (
            element.innerHTML
              .toLowerCase()
              .indexOf(this.quickfind_view.toLowerCase()) > -1
          ) {
            element.style.display = "block";
          }
        });
      } else {
        let lstcrds = document.querySelectorAll(".findme_view");
        lstcrds.forEach((element) => {
          element.style.display = "block";
        });
      }
    },
qfind_updated() {
  const q = (this.quickfind_updated || "").trim();

  // If < 3 chars, show everything
  if (q.length < 3) {
    document.querySelectorAll(".findme-updated").forEach((el) => {
      el.style.display = "block";
    });
    return;
  }

  const needle = q.toLowerCase();
  const cards = document.querySelectorAll(".findme-updated");

  // Hide all first
  cards.forEach((el) => (el.style.display = "none"));

  cards.forEach((el) => {
    // expects :id="'upd' + awd.award_nom_adminId"
    const idint = (el.id || "").slice(3);

    const result = this.lst_updated.find(
      (item) =>
        parseInt(item.award_nom_adminId, 10) === parseInt(idint, 10),
    );

    // If we found the backing record, search the real fields
    if (result) {
      const haystack = [
        result.selectedMedal,
        result.nominatedEmployee,
        result.eventCaseOrCallNumber,
        result.hasSupportingDocumentation,
        result.nominationNarrative,
        result.submittedByEmail,
        result.note,
        result.assigned,
        result.action_log,
      ]
        .filter((v) => typeof v === "string" && v.length)
        .join(" ")
        .toLowerCase();

      if (haystack.includes(needle)) {
        el.style.display = "block";
        return;
      }
    }

    // Fallback: if the rendered HTML contains it, show it
    if ((el.innerHTML || "").toLowerCase().includes(needle)) {
      el.style.display = "block";
    }
  });
},

    qfind_published() {
      //      this.mrbreakpoint("qfind_published");
      let self = this;
      if (
        this.quickfind_published != null &&
        this.quickfind_published.length >= 3
      ) {
        console.log("quickfind_published: " + this.quickfind_published);
        let lstcrds = document.querySelectorAll(".findme-published");
        lstcrds.forEach((element) => {
          element.style.display = "none";
        });

        //find things here
        lstcrds.forEach((element) => {
          // self.mrbreakpoint("qfind_published2");
          let id = element.id;
          let idint = id.slice(3);

          const result = this.lst_published.find(
            (item) => parseInt(item.csigId) === parseInt(idint),
          );
          if (
            result.comments
              .toLowerCase()
              .indexOf(this.quickfind_published.toLowerCase()) > -1
          ) {
            element.style.display = "block";
          }

          if (
            element.innerHTML
              .toLowerCase()
              .indexOf(this.quickfind_published.toLowerCase()) > -1
          ) {
            element.style.display = "block";
          }
        });
      } else {
        let lstcrds = document.querySelectorAll(".findme-published");
        lstcrds.forEach((element) => {
          element.style.display = "block";
        });
      }
    },
qfind() {
  if (this.quickfind != null && this.quickfind.length >= 3) {
    const needle = this.quickfind.toLowerCase();

    const lstcrds = document.querySelectorAll(".findme");
    lstcrds.forEach((el) => (el.style.display = "none"));

    lstcrds.forEach((el) => {
      const id = el.id;          // e.g. "rcv123"
      const idint = id.slice(3); // "123"

      // Match by award_nomId (NOT csigId)
      const result = this.lst_recieved.find(
        (item) => parseInt(item.award_nomId) === parseInt(idint),
      );

      // Guard: if not found, fall back to innerHTML search only
      if (result) {
        // Choose the fields you actually want to search
        const haystack =
          (result.nominationNarrative || "") + " " +
          (result.note || "") + " " +
          (result.nominatedEmployee || "") + " " +
          (result.submittedByEmail || "") + " " +
          (result.eventCaseOrCallNumber || "") + " " +
          (result.selectedMedal || "") + " " +
          (result.status || "");

        if (haystack.toLowerCase().indexOf(needle) > -1) {
          el.style.display = "block";
          return;
        }
      }

      // Also allow search in rendered HTML text
      if (el.innerHTML.toLowerCase().indexOf(needle) > -1) {
        el.style.display = "block";
      }
    });
  } else {
    const lstcrds = document.querySelectorAll(".findme");
    lstcrds.forEach((el) => (el.style.display = "block"));
  }
},


    expnd_textarea() {
      setTimeout(() => {
        let lst_all_textarea = document.querySelectorAll("textarea");
        console.log("expnd_textarea: " + lst_all_textarea.length);
        lst_all_textarea.forEach((textArea) => {
          textArea.style.height = "auto"; // Reset height to calculate full height
          textArea.style.height = `${textArea.scrollHeight}px`; // Set to the full height
        });
      }, 500);
    },
    size_recv_textarea() {
      let lst_all_textarea = document.querySelectorAll(".sizeme");
      lst_all_textarea.forEach((element) => {
        element.style.height = "auto"; // Reset height to calculate full height
        element.style.height = `${element.scrollHeight}px`; // Set to the full height
      });
    },
    deletenow(awd) {
      console.log("deletenow");

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "deletenow";
      formIn.award_nom_adminId = awd.award_nom_adminId;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);

          self.swall_it("Delete Status", "Deleted.", "success", null, null);
          self.new_log_text = "";
          this.$nextTick(() => {
            self.refresh_all();
          });
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    delete_prompt(awd) {
      console.log("delete_prompt");
      let awddel = this.mno(awd);
      let self = this;
      this.swall_diag(
        "Confirm Delete",
        "Do you wish to delete the Award Nomination created on '" +
          awd.s_CreateDate +
          "'? Note: this will only delete the Updated copy and will not affect the originally received Nomination.",
        "question",
        function () {
          self.deletenow(awddel);
        },
        null,
        null,
        function () {},
      );
    },
    new_pubcom() {
      window.open("https://pubcom.renopd.com", "_self");
    },
    close_view() {
      this.show_view = false;
    },
    open_view(awd) {
      this.csig_pub = awd;
      this.show_view = true;
    },
    //new_log_text
    add_to_log(awd) {
      console.log("add_to_log");

      if (awd.action_log == null) {
        awd.action_log = "";
      }

      let new_log_text = this.new_log_text;

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "add_to_log";

      new_log_text =
        formIn.email.toUpperCase() +
        " - " +
        this.format_date_us(new Date()).toString() +
        " " +
        this.formatTimeAsMilitary(new Date()) +
        "--\n " +
        new_log_text +
        " \n\n" +
        awd.action_log;

      awd.action_log = new_log_text;

      formIn.award_nom_adminId = awd.award_nom_adminId;
      formIn.new_log_text = new_log_text;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);

          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null,
          );
          self.new_log_text = "";
          this.$nextTick(() => {
            self.refresh_all();
          });
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    set_assign(awd) {
      this.ass_awd = this.mno(awd);
      this.ass_awd.assigned = "";
      this.show_assing_diag = true;
    },
    set_assign_now() {
         let self = this;
      if (this.$refs.frm_assign.validate() == false) {
        this.swall_it(
          "Save Status",
          "Please check the email format.",
          "warning",
          null,
          null,
        );
        return true;
      }
  self.close_assing_diag();
      console.log("set_assign_now");
      let awd = this.mno(this.ass_awd);
      this.ass_awd = {};

   
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "set_assign_now";
      formIn.award_nom_adminId = awd.award_nom_adminId;
      formIn.award_nom_adminId_award_nomId = awd.award_nom_adminId_award_nomId;
      formIn.assigned = awd.assigned;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
        
          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null,
          );
          //self.$refs.form.reset();
          // self.csig = this.mno(self.new_csig);

          this.$nextTick(() => {
            self.refresh_all();
          });
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    edit_allowed(awd, edit_function) {
      //this.mrbreakpoint("cb");
      console.log("edit_allowed");
      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "has_draft";
      formIn.csigId = awd.csigId;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          if (data == false) {
            edit_function(awd);
          } else {
            self.swall_it(
              "Save Status",
              "This public comment has already been reviewed and used by an administrator. Award Nominations can only be imported once. Please check the Updated section.",
              "warning",
              null,
              null,
            );
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    has_draft_updated(awd) {
      console.log("has_draft_updated : " + awd.csigId);
      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "has_draft";
      formIn.csigId = awd.csigId;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (data == false) {
            self.awd_save_updated(awd);
          } else {
            this.swall_it(
              "Save Status",
              "This Public Comment is not available for saving as it is a draft or is already in another saved state.",
              "warning",
              null,
              null,
            );
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    has_draft_x(awd) {
      //this  has draft is used when the draft is coming from cisg_pub
      console.log("has_draft go");
      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "has_draft";
      formIn.csigId = awd.csigId;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (data == false) {
            self.awd_save_draft(awd);
          } else {
            this.swall_it(
              "Save Draft Status",
              "This Public Comment already has a draft. Only one draft can exist for each Public Comment at a time.",
              "warning",
              null,
              null,
            );
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    has_draft(awd) {
      console.log("has_draft go");
      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "has_draft";
      formIn.csigId = awd.csigId;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          if (data == false) {
            self.awd_save_draft(awd);
          } else {
            this.swall_it(
              "Save Draft Status",
              "This Public Comment already has a draft. Only one draft can exist for each Public Comment at a time.",
              "warning",
              null,
              null,
            );
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    awd_save_draft_x(awd) {
      // if (!this.$refs.form.validate()) {
      //   this.swall_it(
      //     "Save Status",
      //     "Please attend to the Fields marked in red.",
      //     "warning",
      //     null,
      //     null
      //   );
      //   return true;
      // }

      //save it

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "awd_save_draft";

      console.log("sub date: " + awd.submit_date);

      awd.submit_date = this.format_date_sql(awd.submit_date);
      awd.s_date = this.format_date_sql(awd.s_date);
      awd.s_CreateDate = this.format_date_sql(awd.s_CreateDate);

      if (awd.updated_date == "" || awd.updated_date == undefined) {
        awd.updated_date = "1900-01-01";
      }
      if (awd.assigned == "" || awd.assigned == undefined) {
        awd.assigned = "None";
      }

      formIn.csig = awd;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null,
          );
          self.show_edit_dialog_updated = false;
          self.show_edit_dialog = false;
          self.show_edit_dialog_pub = false;

          this.$nextTick(() => {
            self.refresh_all();
          });

          //    self.csig.submit_d()ate = self.format_date_sql(new Date());
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    awd_save_draft(awd) {
      console.log("sub date: " + awd.submit_date);
      if (!this.$refs.form.validate()) {
        this.swall_it(
          "Save Status",
          "Please attend to the Fields marked in red.",
          "warning",
          null,
          null,
        );
        return true;
      }

      //save it

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "awd_save_draft";

      this.csig.submit_date = this.format_date_sql(this.csig.submit_date);
      this.csig.s_date = this.format_date_sql(this.csig.s_date);
      this.csig.s_CreateDate = this.format_date_sql(this.csig.s_CreateDate);

      if (this.csig.updated_date == "" || this.csig.updated_date == undefined) {
        this.csig.updated_date = "1900-01-01";
      }
      if (this.csig.assigned == "" || this.csig.assigned == undefined) {
        this.csig.assigned = "None";
      }

      formIn.csig = this.csig;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null,
          );
          //self.$refs.form.reset();
          // self.csig = this.mno(self.new_csig);
          self.show_edit_dialog_updated = false;
          self.show_edit_dialog = false;
          self.show_edit_dialog_pub = false;

          this.$nextTick(() => {
            self.refresh_all();
          });

          //    self.csig.submit_d()ate = self.format_date_sql(new Date());
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    awd_save_updated(awd) {
      // if (!this.$refs.form.validate()) {
      //   this.swall_it(
      //     "Save Status",
      //     "Please attend to the Fields marked in red.",
      //     "warning",
      //     null,
      //     null
      //   );
      //   return true;
      // }

      //save it

      this.mrbreakpoint("award_nom_adminId: " + awd.award_nom_adminId);
      // If coming from awd_item (Received edit dialog),
        // copy award_nomId into the updated FK field
        if (
          awd.award_nomId &&
          (!awd.award_nom_adminId_award_nomId ||
          awd.award_nom_adminId_award_nomId === 0)
        ) {
          awd.award_nom_adminId_award_nomId = awd.award_nomId;
        }


      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "awd_save_updated";

      awd.submit_date = this.format_date_sql(awd.submit_date);
      awd.s_date = this.format_date_sql(awd.s_date);
      awd.s_CreateDate = this.format_date_sql(awd.s_CreateDate);
      awd.updated_date = this.format_date_sql(awd.updated_date);

      if (awd.assigned == "" || awd.assigned == undefined) {
        awd.assigned = "None";
        awd.assigned_date = "1900-01-01"
      }
      else{
         awd.assigned_date =  this.format_date_sql(  awd.assigned_date );

      }

      formIn.awd = awd;
    this.mrbreakpoint("award_nom_adminId: " + awd.award_nom_adminId);
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null,
          );
          self.show_edit_dialog_updated = false;
          self.show_edit_draft_to_updated = false;
          //self.$refs.form.reset();
          // self.csig = this.mno(self.new_csig);
          self.close_edit_draft_to_updated();
          self.show_edit_draft_to_updated = false;
          self.show_edit_dialog = false;
          this.$nextTick(() => {
            self.refresh_all();
          });

          //    self.csig.submit_d()ate = self.format_date_sql(new Date());
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg.msg, "error", null, null);
        });
    },
    awd_save_published_prompt(awd) {
      let self = this;
      this.swall_diag(
        "Award Nominations",
        "Saving 'As Published' will make this Public Comment and the action log visible to the entire department. Do you wish to continue?",
        "question",
        function () {
          self.awd_save_published(awd);
        },
        null,
        null,
        function () {},
      );
    },
    awd_save_published(awd) {
      if (!this.$refs.form.validate()) {
        this.swall_it(
          "Save Status",
          "Please attend to the Fields marked in red.",
          "warning",
          null,
          null,
        );
        return true;
      }

      //save it

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.apiname = "awd_save_published";

      awd.submit_date = this.format_date_sql(awd.s_CreateDate);
      awd.s_date = this.format_date_sql(awd.s_date);
      awd.s_CreateDate = this.format_date_sql(awd.s_CreateDate);
      awd.updated_date = this.format_date_sql(awd.updated_date);

      if (awd.assigned == "" || awd.assigned == undefined) {
        awd.assigned = "None";
      }

      formIn.awd = awd;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null,
          );
          self.show_edit_dialog_updated = false;

          this.$nextTick(() => {
            self.refresh_all();
          });

          //    self.csig.submit_d()ate = self.format_date_sql(new Date());
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    show_edit_updated_now(awd) {
      console.log("name: " + awd.name);
      console.log("note: " + awd.note)
      this.awd_edit_admin = awd;
      //this.get_reminders4_awd(awd);
     // this.csig_pub = this.mno(awd);
      this.show_edit_dialog_updated = true;
    },
    show_edit_draft_now(awd) {
      this.csig_pub = this.mno(awd);
      this.show_edit_draft_to_updated = true;
    },
    close_edit_draft_to_updated() {
      this.show_edit_draft_to_updated = false;
    },

    show_edit_now(awd) {
      this.awd_item = this.mno(awd);
      this.show_edit_dialog = true;
    },
    close_assing_diag() {
      this.show_assing_diag = false;
    },
    close_edit_pub() {
      this.show_edit_dialog_pub = false;
    },
    close_edit() {
      this.show_edit_dialog = false;
    },
    close_edit_publish() {
      this.show_edit_dialog_updated = false;
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.swall_it(
          "Save Status",
          "Please attend to the Fields marked in red.",
          "warning",
          null,
          null,
        );
        return true;
      }
      //save it

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.apiname = "save_csig";

      this.csig.submit_date = this.format_date_sql(this.csig.submit_date);
      formIn.csig = this.csig;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null,
          );
          self.$refs.form.reset();
          self.csig = this.mno(self.new_csig);

          this.$nextTick(() => {
            console.log("do the date");
            self.csig.submit_date = self.format_date_us(new Date());
          });

          //    self.csig.submit_date = self.format_date_sql(new Date());
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    get_user_props() {
      //not doing this now.

      let self = this;
      self.show_loader(true);
      let formIn = {};
      formIn.apiname = "get_user_props";
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          //data contains the list of all new emps so refresh
          self.user_props = self.mno(data);
          self.new_csig.name =
            self.user_props.fname + " " + self.user_props.lname;

          self.csig = self.mno(self.new_csig);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button does nothing yet.");
    },
    //lst_updated
    // get_all_published() {
    //   let self = this;
    //   self.show_loader(true);
    //   let formIn = {};

    //   formIn.email = this.$store.state.user.email;
    //   formIn.token = this.$store.state.user.token;

    //   formIn.apiname = "get_all_published";

    //   this.$store
    //     .dispatch("anyapi", formIn)
    //     .then((data) => {
    //       self.show_loader(false);
    //       self.lst_published = this.mno(data);
    //       for (let index = 0; index < self.lst_published.length; index++) {
    //         const awd = self.lst_published[index];
    //         awd.s_date = this.format_date_us(awd.s_date);
    //         awd.submit_date = this.format_date_us(awd.submit_date);
    //         awd.s_CreateDate = this.format_date_us(awd.s_CreateDate);
    //         awd.assigned_date = this.format_date_us(awd.assigned_date);

    //         //console.log("pub ass: " + awd.assigned_date);

    //         const tempElement = document.createElement("textarea");
    //         tempElement.innerHTML = awd.request;
    //         awd.request = tempElement.value;

    //         tempElement.innerHTML = awd.solution;
    //         awd.solution = tempElement.value;

    //         tempElement.innerHTML = awd.stream_discuss;
    //         awd.stream_discuss = tempElement.value;

    //         tempElement.innerHTML = awd.comments;
    //         awd.comments = tempElement.value;

    //         tempElement.remove();

    //         //submit_date
    //       }
    //     })
    //     .catch((msg) => {
    //       this.show_loader(false);
    //       this.swall_it("Error", msg, "error", null, null);
    //     });
    // },
    get_all_updated() {
      let self = this;
      self.show_loader(true);
      let formIn = {};

      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_all_updated";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.lst_updated = this.mno(data);
          for (let index = 0; index < self.lst_updated.length; index++) {
            const awd = self.lst_updated[index];
            awd.s_date = this.format_date_us(awd.s_date);
            awd.submit_date = this.format_date_us(awd.submit_date);
            awd.s_CreateDate = this.format_date_us(awd.s_CreateDate);
            awd.assigned_date = this.format_date_us(awd.assigned_date);
             awd.updated_date = this.format_date_us(awd.updated_date);

            const tempElement = document.createElement("textarea");
            tempElement.innerHTML = awd.nominationNarrative;
            awd.nominationNarrative = tempElement.value;
            tempElement.remove();

            const tempElement2 = document.createElement("textarea");
            tempElement2.innerHTML = awd.note;
            awd.note = tempElement2.value;
            tempElement2.remove();

            //submit_date
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    get_user_drafts() {
      let self = this;
      self.show_loader(true);
      let formIn = {};

      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_user_drafts";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.lst_drafts = this.mno(data);
          for (let index = 0; index < self.lst_drafts.length; index++) {
            const awd = self.lst_drafts[index];
            awd.s_date = this.format_date_us(awd.s_date);
            awd.submit_date = this.format_date_us(awd.submit_date);
            awd.s_CreateDate = this.format_date_us(awd.s_CreateDate);
            awd.assigned_date = this.format_date_us(awd.assigned_date);

            const tempElement = document.createElement("textarea");
            tempElement.innerHTML = awd.request;
            awd.request = tempElement.value;
            tempElement.remove();

            //submit_date
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    get_all_recieved() {
      let self = this;
      self.show_loader(true);
      let formIn = {};

      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;

      formIn.apiname = "get_all_recieved";

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.lst_recieved = this.mno(data);
          for (let index = 0; index < self.lst_recieved.length; index++) {
            const awd = self.lst_recieved[index];
            awd.s_date = this.format_date_us(awd.s_date);
            awd.submit_date = this.format_date_us(awd.submit_date);
            awd.s_CreateDate = this.format_date_us(awd.s_CreateDate);
            awd.assigned_date = this.format_date_us(awd.assigned_date);

            awd.text_color = self.set_text_color(awd.status);

           

            // const tempElement = document.createElement("textarea");
            // tempElement.innerHTML = awd.request;
            // awd.request = tempElement.value;

            // tempElement.innerHTML = awd.solution;
            // awd.solution = tempElement.value;

            // tempElement.remove();

            //submit_date
          }
          setTimeout(() => {
            self.size_recv_textarea();
          }, 500);
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },
    set_text_color(status) {
      if (status == "Updated") {
        return "red";
      }
      if (status == "Draft") {
        return "blue";
      }
      if (status == "Published") {
        return "green";
      }
      if (status == "Received") {
        return "purple";
      }
    },
    refresh_all() {
      this.get_all_recieved();
    //  this.get_user_drafts();
      this.get_all_updated();
     // this.get_all_published();
    },
    decodeHtml(html) {
      this.mrbreakpoint("decode)");
      const txt = document.createElement("textarea");
      txt.innerHTML = html;
      const decoded = txt.value;
      txt.remove(); // ← we throw it away immediately
      return decoded;
    },
    init(self) {
      console.log("init");
      this.show_loader(false);
      this.csig = this.mno(this.new_csig);
      this.csig.submit_date = this.format_date_us(new Date());
      console.log("before init refresh all");
      this.refresh_all();
      //this.get_user_props();
      this.show_loader(false);
    },
  },
  mounted() {
    this.show_loader(true);
    var self = this;
    this.$nextTick(() => {
      //self.init();
    });
  },
};
</script>
